import styled from 'styled-components'

const SectionContainer = styled.div`
    height: 100%;
`

export {
    SectionContainer
}